const translations = {
  en: {
    login: "Login",
    username: "Username",
    password: "Password",
    rememberMe: "Remember My Username",
    loginButton: "Log In",
    forgotPassword: "Forgot password?",
    emailemobile: "Enter Email/Mobile Number",
    epassword: "Enter Password",
    home: "Home",
    agencyp: "Agency Profile",
    dashboard: "Dashboard",
    monthlyEnquiries: "Monthly Enquiries",
    monthlyBookings: "Monthly Bookings",
    conversionRate: "Conversion Rate",
    totalRevenue: "Total Revenue (MTD)",
    enquiryBookingTrends: "Enquiry & Booking Trends",
    salesDistributionMonthly: "Sales Distribution (Monthly)",
    quickLinks: "Quick Links",
    addNewLead: "Add New Lead",
    viewAllContacts: "View All Contacts",
    createReport: "Create Report",
    settings: "Settings",
    profile: "Profile",
    personalInformation: "Personal Information",
    emailAddress: "Email Address",
    mobileNumber: "Mobile Number",
    changePassword: "Change Password",
    currentPasswordLabel: "Current Password",
    newPasswordLabel: "New Password",
    confirmNewPasswordLabel: "Confirm New Password",
    changing: "Changing...",
    updatePassword: "Update Password",
    passwordChangedSuccess: "Password changed successfully!",
    failedToChangePassword: "Failed to change password. Please try again.",
    sale: "Sale",
    enquiry: "Enquiry",
    enquiryDashboard: "Enquiry Dashboard",
    stagename: "Stage Name",
    whatsappnumber: "WhatsApp Number",
    manufacturename: "Manufacture Name",
    modelname: "Model Name",
    newtractorprice: "New Tractor Price",
    oldtractors: "Old Tractors",
    oldtractorprice: "Old Tractor Price",

    primarysource: "Primary Source",
    enquirysource: "Enquiry Source",
    createdby: "Created By",
    nextfollowupdate: "Next Followup Date",
    id: "ID",
    new: "New",
    hot: "Hot",
    cold: "Cold",
    warm: "Warm",
    new_description: "Manage fresh enquiries promptly.",
    hot_description: "Focus on high-priority, urgent leads.",
    cold_description: "Review lower-priority or dormant enquiries.",
    warm_description: "Engage with moderately interested prospects.",
    old_tractor_enquiry: "Old Tractor Enquiry",
    old_tractor_description: "Review old tractor enquiries.",
    service: "Service",
    products: "Products",
    sales: "Sales",
    management: "Management",
    manage: "Manage",
    administration: "Administration",
    roles: "Roles",
    users: "Users",
    employee: "Employee",
    configuration: "Configuration",
    Task: "Task",
    AssignTask: "AssignTask",
    TotalEnquiry: "Total Enquiry",
    WorkAssignArea: "Work Assigned Area",
    enquirysources: "Enquiry sources",
    enquirysourcesmodel: "enquiry sources model",
    report: "Report",
    firstname: "First Name",
    lastname: "Last Name",
    phoneno: "Phone Number",
    email: "Email",
    product: "Product",
    salesp: "Sales Person",
    enqdate: "Enquiry Date",
    expdelivery: "Expected Delivery",
    expdeliveryd: "Expected Delivery Date",
    district: "District",
    taluka: "Taluka",
    village: "Village",
    sourceofenq: "Source Of Enquiry",
    addenq: "Add Enquiry",
    workassign: "Work Assign",
    emptype: "Employee Type",
    active: "Active",
    usertype: "User Type",
    adduser: "Add User",
    roledes: "Role Discription",
    basicsetup: "BASIC SETUP",
    state: "State",
    agency: "Agency",
    agencysetting: "AGENCY SETTING",
    mastersetting: "MASTER SETTING",
    branch: "Branch",
    category: "Category",
    department: "Department",
    manufacturer: "Manufacturer",
    task: "Task",
    enqsources: "Enquiry Sources",
    part: "PART",
    partlist: "partlist",
    servicelist: "Service List",
    parts: "Part",
    tax: "TAX",
    taxs: "Tax",
    name: "Name",
    person: "Person",
    logo: "Logo",
    save: "Save",
    create: "Create",
    cancel: "Cancel",
    download: "Download",
    android: "Android",
    ios: "iOS",
    back: "Back",
    totalenq: "Total Enquiry",
    workassinarea: "Work Assigned Area",
    workreport: "Work Report",
    download: "Download",
    statename: "State Name",
    statedes: "State Discription",
    edit: "Edit",
    delete: "Delete",
    deleteconfirmation: "Delete Confirmation",
    areyousuredelete: "Are You Sure You Want To Delete The",
    deletebranchmsg: "Are You Sure You Want To Delete The branch",
    confirmdelete: "Confirm Delete",
    deleteitemmsg: "Are You Sure You Want To Delete This Item",
    deletesuccessfully: "Item deleted successfully",
    deletefailed: "Failed to delete item",
    delivered: "Delivered",
    invalid: "Invalid",
    lost: "Lost",
    dataoverview: "Data Overview",
    itlcustomer: "ITL Customer",
    ssp: "SSP",
    vfs: "VFS",
    karigar: "KARIGAR",
    agrolavar: "AGRO-LAVAR-DUKAN",
    brokar: "BROKAR",
    bagayat: "BAGAYAT",
    sabsidi: "SABSIDI 2025-26-APLAY",
    addstate: "Add State",
    back: "BACK",
    close: "Close",
    save: "Save",
    districtname: "District Name",
    adddistrict: "Add District",
    talukaname: "Taluka Name",
    addtaluka: "Add Taluka",
    villagename: "Village Name",
    addvillage: "Add Village",
    name: "Name",
    emailid: "Email Id",
    aaddress: "Address",
    createdon: "Created On",
    code: "Code",
    newbranch: "New Branch",
    branchname: "Branch Name",
    gstno: "G.S.T Number",
    selectstate: "Select State",
    selectdistrict: "Select District",
    selecttaluka: "Select Taluka",
    contactperson: "Contact Person",
    mobileno: "Mobile Number",
    branchaddress: "Branch Address",
    description: "Description",
    cancel: "Cancel",
    editbranch: "Edit Branch",
    addcategory: "Add Category",
    categoryname: "Category Name",
    categorydescription: "Category Description",
    createcategory: "Create Category",
    editcategory: "Edit Category",
    addcategory_description: "Add a new category to your system",
    savecategory: "Save Category",
    addholiday: "Add Holiday",
    addbank: "Add Bank",
    deletebankmsg: "Are You Sure You Want To Delete The bank",
    bankdeleted: "Bank Deleted",
    bankadded: "Bank Added",
    bankedited: "Bank Edited",
    status: "Status",
    addoffer: "Add Offer",
    offerdeleted: "Offer Deleted",
    failedtodelete: "Failed to delete",
    statusupdated: "Status Updated",
    failedupdate: "Failed to update status",
    inactive: "Inactive",
    areyousuredeleteoffer: "Are You Sure You Want To Delete The offer",
    noUsersBranch: "There is no Users with current branch",
    profiles: "Profiles",
    enquiries: "Enquiries",
    mytask: "My Task",
    employees: "Employees",
    logout: "Logout",
    holiday: "Holiday",
    holidayname: "Holiday Name",
    bankname: "Bank Name",
    offername: "Offer Name",
    editoffer: "Edit Offer",
    addnewoffer: "Add New Offer",
    updateoffer_description: "Update the details for this promotional offer.",
    addoffer_description: "Provide the details for the new promotional offer.",
    offername_placeholder: "e.g., Sonalika Sale 2025",
    startdate: "Start Date",
    enddate: "End Date",
    offercontent: "Offer Content",
    offercontent_placeholder: "e.g., 'Sonalika Dhamaka Offers...'",
    attachment: "Attachment",
    attachment_optional: "Optional: to replace existing",
    clicktoupload: "Click to upload",
    or_dragn_drop: "or drag and drop",
    upload_specs: "PNG, JPG, or PDF (MAX. 10MB)",
    existingfile: "Existing File",
    updating: "Updating...",
    saving: "Saving...",
    updateoffer: "Update Offer",
    saveoffer: "Save Offer",
    please_fill_required_fields: "Please fill out all required fields.",
    enddate_before_startdate: "End Date cannot be before Start Date.",
    error_saving_offer: "An error occurred while saving the offer.",
    offersaved: "Offer saved",
    createagency: "Create Agency",
    selectmanufacturer: "Select Manufacturer",
    configurewhatsapp: "Configure Whatsapp ?",
    appkey: "App Key",
    authkey: "Auth Key",
    selectwhatsappoption: "Select WhatsApp Option",
    whatsappservice: "WhatsApp Service",
    whatsappRC: "WhatsApp RC",
    whatsappBK: "WhatsApp BK",
    pleaseupdatewhatsappkeys:
      "*Please update the whatsapp keys after saving the changes.",
    savechanges: "Save Changes",
    date: "Date",
    editHoliday: "Edit Holiday",
    addleave: "Add Leave",
    myleave: "My leave",
    leavetype: "Leave Type",
    startd: "Start Date",
    endd: "End Date",
    reason: "Reason",
    apply: "Apply",
    tasktype: "Task Type",
    taskcount: "Task Count",
    tasktimep: "Task Time Period",
    workd: "Work Description",
    taskstatus: "Task Status",
    assigntaskmgmt: "Assign Task Management",
    edittaskmgmt: "Edit Task Management",
    message: "Message",
    messages: "Messages",
    addmessage: "Add Message",
    editmsg: "Edit Message",
    messageAction: "MessageAction",
    type: "Type",
    dealstage: "Deal Stages",
    customfield: "Custom Field",
    bank: "Bank",
    inventory: "Inventory",
    reports: "Reports",
    downlodeformate: "Downlode File Formate",
    leadsboard: "Leads board",
    dealStages: "Deal Stages",
    AddvsDelivery: "Add Inquiry v/s Delivery Report",
    notification: "Report notification",
    callreport: "Call Report",
    trackreport: "Track Report",
    data: "Data",
    adddata: "Add Data",
    addbilling: "Add Billing",
    billing: "Billing",
    stocks: "Stocks",
    pipeline: "Pipeline",
    delivery: "Delivery",
    menu: "Menu",
    bilNo: "BIL NO",
    globalSearch: "Global Search...",
    noDataAvailable: "No Data Available",
    rcNumberLabel: "RC NUMBER",
    dispatchedDate: "DISPATCHED DATE",
    dispatched: "Dispatched",
    stock: "Stock",
    addRecord: "Add Record",
    deliveryPipeline: "Delivery Pipeline",
    chassisPrintTitle: "CHASSIS PRINT",
    chassisPrintDetails: "Verify physical chassis number printing.",
    documentsTitle: "DOCUMENTS",
    documentsDetails: "Confirm all required documents are uploaded.",
    parsingPendingTitle: "PARSING PENDING",
    parsingPendingDetails: "Confirm successful completion of parsing.",
    plateOrderTitle: "PLATE ORDER",
    plateOrderDetails: "Check number plate order post-registration.",
    rcFitmentTitle: "RC FITMATE PENDING",
    rcFitmentDetails: "Confirm Fitmate inspection/setup passed.",
    rcDispatchTitle: "PLAT FITTED DISPATCH",
    rcDispatchDetails: "Verify vehicle transfer or dispatch status.",
    number22Title: "22number card",
    number22Details: "Confirm 22 number entry is pending or completed.",
    pendingLabel: "PENDING",
    servicing: "Servicing",
    servicesdue: "Services Due",
    soldout: "Sold Out",
    emailcolon: "Email :",
    currentbranch: "Current branch :",
    lastlogin: "Last login :",
    firsttimelogin: "first time logged in",
    notification: "Notification",
    notficationc: "NOTIFICATION",
    workreport: "Work Report",
    reportnotification: "Report Notification",
    taskreport: "Task Report",
    notificationcontrol: "Notification Control",
    employeeTracking: "EMPLOYEE TRACKING",
    enablelivetracking: "Enable Live Tracking",
    toggleenable: "Toggle to enable or disable live employee tracking.",
    locationupdateinterval: "Location Update Interval",
    selectfrequently:
      "Select how frequently the employee's location should be updated.",
    updateinterval: "Update Interval",
    fiveminutes: "5 Minutes",
    liveemployeemap: "Live Employee Map",
    trackingworkinghours: "Tracking Working Hours",
    submit: "Submit",
    close: "Close",
    employeetracking: "Employee Tracking",
    searchemployees: "Search employees...",
    noemployeesfound: "No employees found.",
    trackingsettings: "Tracking Settings",
    livetracking: "Live Tracking",
    on: "ON",
    off: "OFF",
    thirtyseconds: "30 seconds",
    oneminute: "1 minute",
    fiveminutes: "5 minutes",
    tenminutes: "10 minutes",
    fifteenminutes: "15 minutes",
    thirtymins: "30 Minutes",
    onehour: "1 Hour",
    tracking: "Tracking",
    livemap: "Live-Map",
    enabletext: "Enable",
    disabletext: "Disable",
    enablelivetrackingmodal: "Enable Live Tracking",
    toggletracking: "Toggle to enable or disable live employee tracking.",
    addpart: "ADD PART",
    partname: "Part Name",
    partnumber: "Part Number",
    partdescription: "Part Description",
    hsn: "HSN",
    active: "Active",
    addtax: "Add Tax",
    addtaxmodal: "ADD TAX",
    taxpercent: "Tax(%)",
    percentage: "Percentage",
    slabrate: "Slab Rate",
    add: "Add",
    none: "None",
    adddepartment: "Add Department",
    selectdepartment: "Select Department",
    generaldetails: "General Details",
    profilepicture: "Profile Picture",
    workemail: "Work Email",
    dateofbirth: "Date of Birth",
    bloodgroup: "Blood Group",
    selectbloodgroup: "Select Blood Group",
    bankdetails: "Bank Details",
    bankbranch: "Bank Branch",
    accountnumber: "Account Number",
    accounttype: "Account Type",
    jobinformation: "Job Information",
    reportingmanager: "Reporting Manager",
    accesslevel: "Access Level",
    loginaccess: "Login Access",
    webaccess: "Web Access",
    appaccess: "App Access",
    bothaccess: "Both Access",
    selectbranch: "Select Branch",
    selectoneormorebranch: "Select one or more branch",
    availablebranches: "Available branches",
    selectedcount: "Selected",
    addemployee: "Add Employee",
    employeecreated: "Employee Successfully Created",
    employeeupdated: "Employee updated successfully",
    pleaseselectbranchroles: "Please Select Branch Roles",
    must_be_50: "Must be 50 characters or less",
    required: "Required",
    invalid_email: "Invalid email address",
    must_be_10_digits: "Must be exactly 10 digits",
    password_required: "Password Required",
    birthdate_future: "Birthdate cannot be in the future",
    email_already_exist: "*Please use a different email to continue!",
    selectbankname: "Select Bank Name",
    selectaccounttype: "Select Account Type",
    selectreportingmanager: "Select Reporting Manager",
    done: "Done",
    addassignarea: "Add Assign Area",
    editassignarea: "Edit Assign Area",
    selectcategory: "Select Category",
    searchforacategory: "Search for a category...",
    selectvillageswanttoassign: "Select Villages want to assign",
    searchforavillage: "Search for a village...",
    close: "Close",
    save: "Save",
    areyousuredeleteassignarea:
      "Are You Sure You Want To Delete The Assign Area of",
    assignareadeleted: "Assign Area Deleted",

    // AddTask validation messages
    select_at_least_one_employee: "Select at least one employee",
    task_type_required: "Task Type is required",
    task_required: "Task is required",
    select_at_least_one_category: "Select at least one category",
    must_be_number: "Must be a number",
    must_be_positive: "Must be positive",
    task_count_required: "Task count is required",
    time_period_required: "Time period is required",
    allocation_type_required: "Allocation type is required",
    start_date_required: "Start Date is required",
    end_date_required: "End Date is required",
    end_date_after_start: "End date must be after start date",
    taskadded: "Task Added Successfully",
    taskupdated: "Task Updated Successfully",
    somethingwrong: "Something is wrong!",
    required: "Required",
    selectparentfield: "Select Parent Field",
    selectparentfieldplaceholder: "Select Parent Field",
    entercustomlabel: "Enter Custom Label",
    selectfieldtype: "Select Field Type",
    selectfieldtypeplaceholder: "Select Field Type",
    fieldtype_textbox: "Text Box",
    fieldtype_selectbox: "Select Box",
    fieldtype_checkbox: "Checkbox",
    fieldtype_radiobutton: "Radio Button",
    fieldtype_date: "Date Box",
    addfield: "Add Field",
    showallcustomfieldhint:
      "To show all custom field list please select particular parent field",
    fieldcreated: "Field Created",
    childfieldcreated: "Child Field Created",
    fielddeleted: "Field Deleted",
    fielddeletefailed: "Failed to delete field",
    createdepartment: "Create Department",
    editdepartment: "Edit Department",
    departmentname: "Department name",
    departmentdescription: "Department description",
    addmanufacturer: "Add Manufacturer",
    manufacturername: "Manufacturer Name",
    manufacturerdescription: "Manufacturer Description",
    manufacturerlink: "Manufacturer Link",
    manufacturerfile: "Manufacturer File",
    addmodal: "Add Modal",
    editmodal: "Edit Modal",
    modalname: "Modal Name",
    modallink: "Modal Link",
    brochurefile: "Brochure File",
    modallist: "Modal List",
    update: "Update",
    manufacturer: "Manufacturer",
    manufacture: "Manufacture",
    modal: "Modal",
    areyousuredeletemodal: "Are You Sure You Want To Delete The Modal",
    enquirysourceslist: "Enquiry Sources List",
    enquiryprimarysourcesname: "Enquiry Primary Sources Name",
    addenquiryprimarysource: "ADD Enquiry Primary Source",
    enquiryprimarysourcename: "Enquiry Primary Source Name",
    enquiryprimarysourcedescription: "Enquiry Primary Source Description",
    addenquirysource: "ADD ENQUIRY SOURCE",
    editsourcesname: "EDIT ENQUIRY SOURCE",
    enquirysourcesname: "Enquiry Sources Name",
    areyousureadddelete: "Are you sure you want to delete the enquiry source",
    areyousuredbdelete: "Are You Sure You Want To Delete The Enquiry Sources",
    isactive: "Is Active",
    offer: "Offer",
    whatsapp: "WhatsApp",
    agencypicture: "Agency Picture",
    messagelist: "Message List",
    action: "Action",
    userinfo: "User Information",
    assignarea: "Assign Area",
    areaAssign: "Area-Assign",
    addAsignArea: "Add-AsignArea",
    newrole: "New Role",
    editrole: "Edit Role",
    rolename: "Role Name",
    enterrolename: "Enter the role name",
    roledescription: "Role Description",
    enteroledescription: "Enter a description for the role",
    assignedfeatures: "Assigned Features",
    selectfeatures: "Select the features you want to assign to this role.",
    createrole: "Create Role",
    pleasefillallfield: "Please fill all the field",
    roleiscreated: "Role is created",
    deleterolmsg: "Are You Sure You Want To Delete The Role",
    taskreport: "Task Report",
    taskreportdesc: "Manage and track tasks",
    salesreport: "Sales Report",
    salesreportdesc: "Analyze sales performance",
    trackingreport: "Tracking Report",
    trackingreportdesc: "Track progress and movements",
    activityreport: "Activity Report",
    activityreportdesc: "Monitor daily activities",
    leadreport: "Lead Report",
    leadreportdesc: "Track leads and conversions",
    targetreport: "Target Report",
    targetreportdesc: "Monitor target achievement and progress",
    weeklytargets: "Weekly Targets",
    monthlytargets: "Monthly Targets",
    annualtargets: "Annual Targets",
    opportunityreport: "Opportunity Report",
    opportunityreportdesc: "View potential opportunities",
    campaignreport: "Campaign Report",
    campaignreportdesc: "Assess campaign performance",
    customerreport: "Customer Report",
    customerreportdesc: "Understand customer demographics",
    supportticketreport: "Support Ticket Report",
    supportticketreportdesc: "Monitor support tickets",
    financialreport: "Financial Report",
    financialreportdesc: "Overview of financial metrics",
    dailysales: "Daily Sales",
    monthlysales: "Monthly Sales",
    customsales: "Custom Sales",
    annualsales: "Annual Sales",
    dailytracking: "Daily Tracking",
    weeklytracking: "Weekly Tracking",
    monthlytracking: "Monthly Tracking",
    dailyactivity: "Daily Activity",
    weeklyactivity: "Weekly Activity",
    monthlyactivity: "Monthly Activity",
    newleads: "New Leads",
    convertedleads: "Converted Leads",
    customleadreport: "Custom Lead Report",
    openopportunities: "Open Opportunities",
    closedopportunities: "Closed Opportunities",
    customopportunity: "Custom Opportunity",
    emailcampaign: "Email Campaign",
    socialcampaign: "Social Campaign",
    customcampaign: "Custom Campaign",
    activecustomers: "Active Customers",
    inactivecustomers: "Inactive Customers",
    customcustomerreport: "Custom Customer Report",
    opentickets: "Open Tickets",
    pendingtickets: "Pending Tickets",
    resolvedtickets: "Resolved Tickets",
    customsupportreport: "Custom Support Report",
    revenuereport: "Revenue Report",
    expensereport: "Expense Report",
    profitanalysis: "Profit Analysis",
    customfinancialreport: "Custom Financial Report",
    distributiontype: "Distribution Type",
    addrole: "Add Role",
    allreports: "All Reports",
    analytics: "Analytics",
    id: "ID",
    employeeName: "Employee Name",
    categoryName: "Category Name",
    customerName: "Customer Name",
    phoneNumber: "Phone Number",
    village: "Village",
    taskName: "Task Name",
    outcomeStatus: "Outcome Status",
    attemptDate: "Attempt Date",
    notes: "Notes",
    selectEmployee: "Select Employee",
    selectCategory: "Select Category",
    selectStatus: "Select Status",
    startDate: "Start Date",
    endDate: "End Date",
    taskAnalyticsReport: "Task Analytics Report",
    loadingPleaseWait: "Loading, please wait...",
    tasklist: "Task List",
    allocationtype: "Allocation Type",
    taskarea: "Task Area",
    tasktype: "Task Type",
    selectTaskType: "Select Task Type",
    selectTask: "Select Task",
    selectTaskTimePeriod: "Select Task Time Period",
    taskAllocationtype: "Task Allocation Type",
    selectAllocationtype: "Select Allocation Type",
    selectTaskArea: "Select Task Area",
    areaAllocatedPerson: "Area Allocated Person",
    selectAreaAllocatedPerson: "Select Area Allocated Person",
    outcomeType: "Outcome Type",
    selectOutcometype: "Select Outcome Type",
    taskStatus: "Task Status",
    selectTaskStatus: "Select Task Status",
    updateTask: "Update Task",
    createTask: "Create Task",
    addtask: "Add Task",
    edittask: "Edit Task",
    globalSearch: "Global Search...",
    download: "Download",
    revert: "Revert",
    no: "No",
    customerName: "Customer Name",
    village: "Village",
    taluka: "Taluka",
    phoneNumber: "Phone Number",
    deliveryDate: "Delivery Date",
    soldDate: "Sold Date",
    soldNote: "Sold Note",
    model: "Model",
    chassisNo: "CHASSIS NO",
    engineNo: "ENGINE NO",
    noDataAvailable: "No Data Available",
    confirmRevert: "Confirm Revert",
    areYouSureRevert:
      "Are you sure you want to revert this tractor from 'Sold Out' status?",
    yes: "Yes",
    yesRevert: "Yes, Revert",
    no: "No",
    followUp: "Follow Up",
    lastServiceHours: "Last Service Hours",
    serviceHours: "Service Hours",
    tractorSold: "Tractor Sold",
    tractorSoldStatus: "Tractor Sold Status",
    selectOption: "Select an option...",
    additionalInfo: "Additional Info / Remarks",
    customerDetails: "Customer Details",
    pleaseFillDetails: "Please fill in the necessary details for",
    saveData: "Save Data",
    enterPlaceholder: "Enter {field}...",
    back: "Back",
    scheduledService: "Scheduled Service",
    dueDate: "Due Date",
    scheduleNote: "Schedule Note",
    lastServiceNote: "Last Service Note",
    modal: "Modal",
    chassis: "Chassis",
    engine: "Engine",
    totalHours: "Total Hours",
    servicesDue: "Services Due",
    serviceDetails: "Service Details",
    serviceAndCustomerInfo: "Service & Customer Info",
    associatedServices: "Associated Services",
    loadingPleaseWait: "Loading, please wait...",
    noServicesAvailable: "No Services Available",
    thService: "th Service",
    serviceMilestone: "Service Milestone",
    customerName: "Customer Name",
    dueDate: "Due Date",
    modal: "MODAL",
    chassis: "CHASSIS",
    engine: "ENGINE",
    lastHours: "Last Hours",
    totalHours: "Total Hours",
    deliveryDate: "Delivery Date",
    globalSearch: "Global Search...",
    noDataAvailable: "No Data Available",
    allServicesData: "All Services Data",
    financialYear: "Financial Year",
    download: "Download",
    model: "Model",
    chassisNo: "CHASSIS NO",
    engineNo: "ENGINE NO",
    manufacture: "Manufacture",
    chassisNumber: "Chassis No",
    engineNumber: "Engine No",
    taluka: "Taluka",
    village: "Village",
    phoneNumber: "Phone Number",
    menu: "Menu",
    pdfPreview: "PDF Preview",
    serviceFollowUp: "Service Follow-up",
    customer: "Customer",
    phone: "Phone",
    followUpNote: "Follow-up Note",
    nextFollowUpDate: "Next Follow-up Date",
    followUpHistory: "Follow-up History",
    date: "Date",
    nextFollowUp: "Next Follow-Up",
    note: "Note",
    followedBy: "Followed By",
    cancel: "Cancel",
    submit: "Submit",
    recordService: "Record Service",
    lastServiceHours: "Last Service Hours",
    serviceDate: "Service Date",
    serviceNote: "Service note...",
    followUp: "Follow Up",
    no: "No",
    name: "Name",
    modelName: "Model Name",
    engineNumber: "Engine Number",
    chassisNumber: "Chassis Number",
    detailedServiceOverview: "Detailed Service Overview",
    engineHash: "Engine #",
    chassisHash: "Chassis #",
    model: "Model",
    lastServiceHours: "Last Service Hours",
    downloadPdf: "Download PDF",
    downloadExcel: "Download Excel",
    followUp: "Follow Up",
    sold: "Sold",
    due: "Due",
    bilNo: "BIL NO",
    ndp: "NDP",
    bumCod: "BUM COD",
    modal: "MODAL",
    chassis: "CHASSIS",
    engine: "ENGINE",
    deliveryDate: "Delivery Date",
    customerName: "Customer Name",
    sample: "Sample",
    upload: "Upload",
    exportCsv: "Export CSV",
    bil: "BIL",
    steps: "Steps",
    location: "Location",
    stagename: "Stage Name",
    user: "User",
    deliverysalesman: "Delivery Salesman",
    enquiryad: "Enquiry Ad",
    customerName: "Customer Name",
    retailDate: "Retail Date",
    remainingPrice: "Remaining Price",
    isOldOwned: "Is Old Owned?",
    selectDistrict: "Select District",
    selectTaluka: "Select Taluka",
    selectVillage: "Select Village",
    selectEnquirySource: "Select Enquiry Source",
    selectDeliverySalesman: "Select Delivery Salesman",
    selectSalesPerson: "Select Sales Person",
    enquiryAd: "Enquiry Ad",
    selectEnquiryAd: "Select Enquiry Ad",
    selectModel: "Select Model",
    selectChassis: "Select Chassis",
    selectEngine: "Select Engine",
    selectMake: "Select Make",
    selectYear: "Select Year",
    paymentMethod: "Payment Method",
    selectPaymentMethod: "Select Payment Method",
    paymentDetails: "Payment Details",
    selectPaymentDetails: "Select Payment Details",
    selectBankName: "Select Bank Name",
    make: "Make",
    year: "Year",
    saveChanges: "Save Changes",
  },
  gj: {
    login: "લોગિન",
    username: "વપરાશકર્તા નામ",
    password: "પાસવર્ડ",
    rememberMe: "મારું વપરાશકર્તા નામ યાદ રાખો",
    loginButton: "લોગીન બટન",
    forgotPassword: "તમે તમારો પાસવર્ડ ભૂલ્યો છો?",
    emailemobile: "ઈમેલ/મોબાઈલ નંબર દાખલ કરો",
    epassword: "પાસવર્ડ દાખલ કરો",
    home: "હોમ ",
    sale: "સેલ",
    dashboard: "ડેશબોર્ડ",
    monthlyEnquiries: "માસિક પૂછપરછો",
    monthlyBookings: "માસિક બુકિંગ્સ",
    conversionRate: "રૂપાંતરણ દર",
    totalRevenue: "કુલ આવક (MTD)",
    enquiryBookingTrends: "પૂછપરછ અને બુકિંગ ટ્રેન્ડ્સ",
    salesDistributionMonthly: "વેચાણ વિતરણ (માસિક)",
    quickLinks: "ઝટપટ કડીઓ",
    addNewLead: "નવો લીડ ઉમેરો",
    viewAllContacts: "બધા સંપર્ક જુઓ",
    createReport: "અહેવાલ બનાવો",
    settings: "સેટિંગ્સ",
    profile: "પ્રોફાઇલ",
    personalInformation: "વ્યક્તિગત માહિતી",
    emailAddress: "ઈમેલ સરનામું",
    mobileNumber: "મોબાઇલ નંબર",
    changePassword: "પાસવર્ડ બદલો",
    currentPasswordLabel: "વર્તમાન પાસવર્ડ",
    newPasswordLabel: "નવી પાસવર્ડ",
    confirmNewPasswordLabel: "નવી પાસવર્ડ પુષ્ટિ કરો",
    changing: "બદલી રહ્યું છે...",
    updatePassword: "પાસવર્ડ અપડેટ કરો",
    passwordChangedSuccess: "પાસવર્ડ સફળતાપૂર્વક બદલાયો!",
    failedToChangePassword:
      "પાસવર્ડ બદલવામાં નિષ્ફળ. કૃપા કરીને ફરી પ્રયાસ કરો.",
    agencyp: "એજન્સી પ્રોફાઇલ",
    enquiry: "પૂછપરછ",
    enquiryDashboard: "પૂછપરછ પેનલ",
    stagename: "સ્ટેજ",
    whatsappnumber: "વોટ્સએપ નંબર",
    manufacturename: "ઉત્પાદક",
    modelname: "મોડલ",
    newtractorprice: "નવો ટ્રેક્ટર ભાવ",
    oldtractors: "જુના ટ્રેક્ટર",
    oldtractorprice: "જુના ટ્રેક્ટરનો ભાવ",
    primarysource: "મુખ્ય સ્ત્રોત",
    enquirysource: "પૂછપરછ સ્ત્રોત",
    createdby: "કોણે બનાવ્યું",
    nextfollowupdate: "આગલી અનુવર્તી તારીખ",
    id: "આઈ.ડી.",
    new: "નવો",
    hot: "હોટ",
    cold: "કોલ્ડ",
    warm: "વોર્મ",
    new_description: "નવી પૂછપરછોને તરત જુઓ.",
    hot_description: "તાત્કાલિક અને મહત્વની પૂછપરછો.",
    cold_description: "ઓછી પ્રાથમિકતાની પૂછપરછો.",
    warm_description: "મધ્યમ રસ ધરાવતી પૂછપરછો.",
    old_tractor_enquiry: "જૂના ટ્રેક્ટર પૂછપરછ",
    old_tractor_description: "જૂના ટ્રેક્ટર સંબંધિત પૂછપરછ જુઓ.",
    service: "સર્વિસ",
    products: "પ્રોડક્ટસ",
    sales: "સેલ્સ",
    management: "મૈનેજમેન્ટ",
    manage: "મૈનેજ",
    administration: "એડમિનિસ્ટ્રેશન",
    roles: "ભૂમિકાઓ",
    users: "યુઝર્સ",
    employee: "કર્મચારી",
    configuration: "કન્ફિગરેસન",
    Task: "કાર્ય",
    AssignTask: "કાર્ય સોંપો",
    TotalEnquiry: "કુલ પૂછપરછ",
    WorkAssignArea: "કાર્ય સોંપાયેલ વિસ્તાર",
    enquirysources: "પૂછપરછ સ્ત્રોતો",
    enquirysourcesmodel: "પૂછપરછ સ્ત્રોત મોડલ",
    partlist: "ભાગ યાદી",
    servicelist: "સર્વિસ યાદી",
    report: "રિપોર્ટ",
    firstname: "ફર્સ્ટ નેમ",
    lastname: "લાસ્ટ નેમ ",
    phoneno: "ફોન નંબર ",
    email: "ઈમેલ",
    product: "પ્રોડક્ટ",
    salesp: "સેલ્સ મેન ",
    enqdate: "પૂછપરછની તારીખ",
    expdelivery: "અપેક્ષિત ડિલિવરી",
    expdeliveryd: "અપેક્ષિત ડિલિવરી તારીખ",
    district: "જિલ્લો",
    taluka: "તાલુકો",
    village: "ગામ",
    sourceofenq: "પૂછપરછનો સ્ત્રોત",
    addenq: "પૂછપરછ ઉમેરો",
    addholiday: "રજા દિવસ ઉમેરો",
    addbank: "બેંક ઉમેરો",
    deletebankmsg: "શું તમે બેંક ડીલીટ કરવા માટે સહમત છો",
    bankdeleted: "બેંક કાઢી લેવામાં આવી",
    bankadded: "બેંક ઉમેરાઈ ગઈ",
    bankedited: "બેંક એડિટ થઈ ગઈ",
    addoffer: "ઓફર ઉમેરો",
    createagency: "એજન્સી બનાવો",
    selectmanufacturer: "ઉત્પાદક પસંદ કરો",
    configurewhatsapp: "વોટ્સએપ રૂપરેખા",
    appkey: "એપ કી",
    authkey: "ઑથ કી",
    selectwhatsappoption: "વોટ્સએપ વિકલ્પ પસંદ કરો",
    whatsappservice: "વોટ્સએપ સેવા",
    whatsappRC: "વોટ્સએપ આરસી",
    whatsappBK: "વોટ્સએપ બીએક",
    selectmanufacturer: "ઉત્પાદક પસંદ કરો",
    pleaseupdatewhatsappkeys:
      "*કૃપા કરીને બદલાઓ સાચવ્યા પછી વોટ્સએપ કીઓ અપડેટ કરો.",
    savechanges: "બદલાવ સંગ્રહિત કરો",
    offerdeleted: "ઓફર કાઢી નાખવામાં આવી",
    failedtodelete: "ડિલીટ કરવામાં નિષ્ફળ",
    statusupdated: "સ્થિતિ અપડેટ થઈ ગઈ",
    failedupdate: "સ્થિતિ અપડેટ કરવામાં નિષ્ફળ",
    inactive: "નિષ્ક્રિય",
    areyousuredeleteoffer: "શું તમે ઓફર ડીલીટ કરવા માટે સહમત છો",
    noUsersBranch: "વર્તમાન શાખા માટે કોઈ યુઝર્સ નથી",
    editoffer: "ઓફર એડિટ કરો",
    addnewoffer: "નવી ઓફર ઉમેરો",
    updateoffer_description: "આ પ્રમોશનલ ઓફરની વિગતો અપડેટ કરો.",
    addoffer_description: "નવી પ્રમોશનલ ઓફરની વિગતો પ્રદાન કરો.",
    offername_placeholder: "જેમકે, સોનાલિકા સેલ 2025",
    startdate: "શરૂઆત તારીખ",
    enddate: "અંત તારીખ",
    offercontent: "ઓફર સામગ્રી",
    offercontent_placeholder: "જેમકે, 'સોનાલિકા ધમાકા ઑફર્સ...'",
    attachment: "અટૅચમેન્ટ",
    attachment_optional: "વિકલ્પ છે: વર્તમાનને બદલવા માટે",
    clicktoupload: "અપલોડ કરવા માટે ક્લિક કરો",
    or_dragn_drop: "કે ડ્રેગ અને ડ્રોપ કરો",
    upload_specs: "PNG, JPG, અથવા PDF (સর্বોચ્ચ 10MB)",
    existingfile: "હાલની ફાઇલ",
    updating: "અપડેટ થઈ રહ્યું છે...",
    saving: "સાચવવામાં આવી રહ્યું છે...",
    updateoffer: "ઓફર અપડેટ કરો",
    saveoffer: "ઓફર સાચવો",
    please_fill_required_fields: "કૃપા કરીને તમામ જરૂરી ક્ષેત્રો ભરો.",
    enddate_before_startdate: "અંત તારીખ શરૂ થતાની પહેલા ન હોઈ શકે.",
    error_saving_offer: "ઓફર સાચવતી વખતે નિષ્ફળતા બની.",
    offersaved: "ઓફર સાચવાઈ છે",
    workassign: "કામ સોંપવું",
    emptype: "કર્મચારી પ્રકાર",
    active: "સક્રિય",
    usertype: "યુઝર પ્રકાર",
    adduser: "એડ યુઝર",
    roledes: "ભૂમિકા વર્ણન",
    basicsetup: "મૂળભૂત સેટઅપ",
    state: "રાજ્ય",
    agency: "એજન્સી",
    agencysetting: "એજન્સી સેટિંગ",
    mastersetting: "માસ્ટર સેટિંગ",
    branch: "શાખા",
    category: "શ્રેણી",
    department: "વિભાગ",
    manufacturer: "ઉત્પાદક",
    task: "કાર્ય",
    enqsources: "પૂછપરછ સ્ત્રોતો",
    part: "ભાગ",
    parts: "ભાગ",
    tax: "ટેક્સ",
    taxs: "ટેક્સ",
    name: "નામ",
    person: "વ્યક્તિ",
    logo: "લોગો",
    save: "સાચવો",
    create: "બનાવો",
    cancel: "રદ કરો",
    download: "ડાઉનલોડ કરો",
    android: "એન્ડ્રોઇડ",
    ios: "આઈઓએસ",
    back: "પાછા",
    totalenq: "કુલ પૂછપરછ",
    workassinarea: "કાર્ય સોંપાયેલ વિસ્તાર",
    workreport: "કાર્ય અહેવાલ",
    download: "ડાઉનલોડ",
    statename: "રાજ્યનું નામ",
    statedes: "રાજ્ય વર્ણન",
    edit: "એડિટ",
    delete: "ડીલીટ",
    deleteconfirmation: "ડીલીટ કરવાની પુષ્ટિ",
    areyousuredelete: "શું તમે વિભાગ ડીલીટ કરવા માટે સહમત છો",
    deletebranchmsg: "શું તમે શાખા ડીલીટ કરવા માટે સહમત છો",
    confirmdelete: "ડીલીટ કરવાની પુષ્ટિ કરો",
    deleteitemmsg: "શું તમે આ આઇટમ ડીલીટ કરવા માટે સહમત છો",
    deletesuccessfully: "આઇટમ સફળતાપૂર્વક ડીલીટ કર્યું",
    deletefailed: "આઇટમ ડીલીટ કરવામાં નિષ્ફળ",
    delivered: "ડિલિવર થયું",
    invalid: "ગલત",
    lost: "ગુમાયું",
    dataoverview: "ડેટા સારાંશ",
    itlcustomer: "ITL ગ્રાહક",
    ssp: "SSP",
    vfs: "VFS",
    karigar: "કારીગર",
    agrolavar: "ખેતીની દુકાન",
    brokar: "બ્રોકર",
    bagayat: "બાગાયત",
    sabsidi: "સબસીડી 2025-26",
    addstate: "રાજ્ય ઉમેરો",
    back: "પાછા",
    close: "બંધ",
    save: "સેવ",
    districtname: "જિલ્લાનું નામ",
    adddistrict: "જિલ્લો ઉમેરો",
    talukaname: "તાલુકાનું નામ",
    addtaluka: "તાલુકા ઉમેરો",
    villagename: "ગામનું નામ",
    addvillage: "ગામ ઉમેરો",
    name: "નામ",
    emailid: "ઈમેલ આઈડી",
    address: "સરનામું",
    createdon: "બનાવેલી તારીખ",
    code: "કોડ",
    newbranch: "નવી શાખા",
    branchname: "શાખાનું નામ",
    gstno: "G.S.T નંબર",
    selectstate: "રાજ્ય પસંદ કરો",
    selectdistrict: "જિલ્લો પસંદ કરો",
    selecttaluka: "તાલુકો પસંદ કરો",
    contactperson: "સંપર્ક વ્યક્તિ",
    mobileno: "મોબાઇલ નંબર",
    branchaddress: "શાખા સરનામું",
    description: "વર્ણન",
    cancel: "રદ કરો",
    editbranch: "શાખા એડિટ કરો",
    addcategory: "શ્રેણી ઉમેરો",
    categoryname: "શ્રેણીનું નામ",
    categorydescription: "શ્રેણીનું વર્ણન",
    createcategory: "શ્રેણી બનાવો",
    editcategory: "શ્રેણી એડિટ કરો",
    addcategory_description: "તમારી સિસ્ટમમાં નવી શ્રેણી ઉમેરો",
    savecategory: "શ્રેણી સાચવો",
    profiles: "પ્રોફાઇલ્સ",
    enquiries: "પૂછપરછો",
    mytask: "મારું કાર્ય",
    employees: "કર્મચારીઓ",
    logout: "લૉગ આઉટ",
    holiday: "વિશ્રામ દિવસ",
    holidayname: "રજાનું નામ",
    bankname: "બેંકનું નામ",
    date: "તારીખ",
    editHoliday: "રજા એડિટ કરો",
    addleave: "રજા ઉમેરો",
    myleave: "મારી રજા",
    leavetype: "રજાનો પ્રકાર",
    startd: "પ્રારંભ તારીખ",
    endd: "અંતિમ તારીખ",
    reason: "કારણ",
    apply: "અરજી કરો",
    tasktype: "કાર્ય પ્રકાર",
    taskcount: "કાર્ય ગણતરી",
    tasktimep: "કાર્ય સમય અવધિ",
    workd: "કામ વર્ણન",
    taskstatus: "કાર્ય સ્થિતિ",
    assigntaskmgmt: "કાર્ય વ્યવસ્થાપન સોંપો",
    edittaskmgmt: "કાર્ય વ્યવસ્થાપન એડિટ કરો",
    message: "મેસેજ",
    messagelist: "મેસેજ લિસ્ટ",
    addmessage: "મેસેજ ઉમેરો",
    messageAction: "મેસેજ એક્શન",
    type: "પ્રકાર",
    dealstage: "ડીલ સ્ટેજ",
    dealStages: "ડીલ સ્ટેજ",
    inventory: "ઇન્વન્ટૉરી",
    reports: "રિપોર્ટ્સ",
    customfield: "કસ્ટમ ફીલ્ડ",
    bank: "બેંક",
    downlodeformate: "ફાઇલ ફોર્મેટ ડાઉનલોડ કરો",
    data: "ડેટા",
    adddata: "ડેટા ઉમેરો",
    addbilling: "બિલીંગ ઉમેરો",
    billing: "બિલીંગ",
    stocks: "સ્ટોક્સ",
    pipeline: "પાઇપલાઇન",
    delivery: "ડિલીવરી",
    menu: "મેનુ",
    bilNo: "BIL NO",
    globalSearch: "ગ્લોબલ શોધ...",
    noDataAvailable: "ડેટા ઉપલબ્ધ નથી",
    rcNumberLabel: "RC નંબર",
    dispatchedDate: "ડિસ્પેચ તારીખ",
    dispatched: "ડિસ્પેચડ",
    stock: "સ્ટોક",
    addRecord: "રેકોર્ડ ઉમેરો",
    deliveryPipeline: "ડિલિવરી પાઇપલાઇન",
    chassisPrintTitle: "ચેસિસ પ્રિન્ટ",
    chassisPrintDetails: "ભૌતિક ચેસિસ નંબરના પ્રિન્ટની ખાતરી કરો.",
    documentsTitle: "દસ્તાવેજો",
    documentsDetails: "આવશ્યક તમામ દસ્તાવેજ અપલોડ થયા છે તેની ખાતરી કરો.",
    parsingPendingTitle: "પાર્સિંગ બાકી",
    parsingPendingDetails: "પાર્સિંગ સફળતાપૂર્વક પૂર્ણ થયું છે તેની ખાતરી કરો.",
    plateOrderTitle: "પ્લેટ ઓર્ડર",
    plateOrderDetails: "નંબર પ્લેટ પોષણ પછીની ખોટ ચોક્સો કરો.",
    rcFitmentTitle: "આરસી ફિટમેટ બાકી",
    rcFitmentDetails: "ફિટમેટ ઈન્સ્પેક્શન/સેટઅપ પસાર થયું છે તેની ખાતરી કરો.",
    rcDispatchTitle: "પ્લેટ ફિટેડ ડિસ્પેચ",
    rcDispatchDetails: "વાહન ટ્રાન્સફર અથવા ડિસ્પેચ સ્થિતિની ખાતરી કરો.",
    number22Title: "22નંબર કાર્ડ",
    number22Details: "22 નંબર એન્ટ્રી બાકી છે કે પૂર્ણ છે તેની તપાસ કરો.",
    pendingLabel: "પેન્ડિંગ",
    servicing: "સર્વિસીંગ",
    servicesdue: "સર્વિસ બાકી",
    soldout: "વેચાઇ ગયું",
    emailcolon: "ઈમેલ :",
    currentbranch: "વર્તમાન શાખા :",
    lastlogin: "છેલ્લો લૉગિન :",
    firsttimelogin: "પ્રથમ વાર લૉગિન કર્યું",
    notification: "નોટિફિકેશન ",
    workreport: "કાર્ય રિપોર્ટ",
    trackreport: "ટ્રેક રિપોર્ટ",
    reportnotification: "રિપોર્ટ નોટિફિકેશન",
    taskreport: "ટાસ્ક રિપોર્ટ",
    notificationcontrol: "નોટિફિકેશન નિયંત્રણ",
    notficationc: "નોટિફિકેશન",
    employeeTracking: "કર્મચારી ટ્રેકિંગ",
    enablelivetracking: "લાઇવ ટ્રેકિંગ ઇનૈબલ કરો",
    toggleenable:
      "લાઇવ કર્મચારી ટ્રેકિંગ ઇનૈબલ અથવા ડિસેબલ કરવા માટે ટોગલ કરો.",
    locationupdateinterval: "સ્થાન અપડેટ અંતરાલ",
    selectfrequently:
      "કર્મચારીનું સ્થાન કેટલી વાર અપડેટ કરવું જોઈએ તે પસંદ કરો.",
    updateinterval: "અપડેટ અંતરાલ",
    fiveminutes: "5 મિનિટ",
    liveemployeemap: "લાઇવ કર્મચારી નકશો",
    trackingworkinghours: "ટ્રેકિંગ કામ કલાકો",
    submit: "સબમિટ",
    close: "બંધ કરો",
    employeetracking: "કર્મચારી ટ્રેકિંગ",
    searchemployees: "કર્મચારીઓ શોધો...",
    noemployeesfound: "કોઈ કર્મચારી મળ્યો નથી.",
    trackingsettings: "ટ્રેકિંગ સેટિંગ્સ",
    livetracking: "લાઇવ ટ્રેકિંગ",
    on: "ચાલુ",
    off: "બંધ",
    thirtyseconds: "30 સેકંડ",
    oneminute: "1 મિનિટ",
    fiveminutes: "5 મિનિટ",
    tenminutes: "10 મિનિટ",
    fifteenminutes: "15 મિનિટ",
    thirtymins: "30 મિનિટ",
    onehour: "1 કલાક",
    tracking: "ટ્રેકિંગ",
    livemap: "લાઇવ-નક્શો",
    enabletext: "ઇનૈબલ કરો",
    disabletext: "ડિસેબલ કરો",
    enablelivetrackingmodal: "લાઇવ ટ્રેકિંગ ઇનૈબલ કરો",
    toggletracking:
      "લાઇવ કર્મચારી ટ્રેકિંગ ઇનૈબલ અથવા ડિસેબલ કરવા માટે ટોગલ કરો.",
    livetracking: "લાઇવ ટ્રેકિંગ",
    addpart: "ભાગ ઉમેરો",
    partname: "ભાગનું નામ",
    partnumber: "ભાગ નંબર",
    partdescription: "ભાગનું વર્ણન",
    hsn: "HSN",
    active: "સક્રિય",
    addtax: "ટેક્સ ઉમેરો",
    addtaxmodal: "ટેક્સ ઉમેરો",
    taxpercent: "ટેક્સ(%)",
    percentage: "ટકાવારી",
    slabrate: "સ્લેબ રેટ",
    add: "ઉમેરો",
    none: "કોઈ નહીં",
    adddepartment: "વિભાગ ઉમેરો",
    selectdepartment: "વિભાગ પસંદ કરો",
    generaldetails: "સામાન્ય વિગત",
    profilepicture: "પ્રોફાઇલ ચિત્ર",
    workemail: "વર્ક ઇમેલ",
    dateofbirth: "જન્મ તારીખ",
    bloodgroup: "બ્લડ ગ્રુપ",
    selectbloodgroup: "બ્લડ ગ્રુપ પસંદ કરો",
    bankdetails: "બેંક વિગતો",
    bankbranch: "બેંક શાખા",
    accountnumber: "એકાઉન્ટ નંબર",
    accounttype: "એકાઉન્ટ પ્રકાર",
    jobinformation: "નોકરીની માહિતી",
    reportingmanager: "રિપોર્ટિંગ મેનેજર",
    accesslevel: "પ્રવેશ સ્તર",
    loginaccess: "લૉગિન ઍક્સેસ",
    webaccess: "વેબ ઍક્સેસ",
    appaccess: "એપ ઍક્સેસ",
    bothaccess: "બેન્નુ ઍક્સેસ",
    selectbranch: "શાખા પસંદ કરો",
    selectoneormorebranch: "એક અથવા વધુ શાખા પસંદ કરો",
    availablebranches: "ઉપલબ્ધ શાખાઓ",
    selectedcount: "પસંદ કરેલ",
    addemployee: "કર્મચારી ઉમેરો",
    employeecreated: "કર્મચારી સફળતાપૂર્વક બનાવાયો",
    employeeupdated: "કર્મચારી સફળતાપૂર્વક અપડેટ થયો",
    pleaseselectbranchroles: "કૃપા કરીને શાખા રોલ્સ પસંદ કરો",
    must_be_50: "50 અક્ષરો અથવા ઓછા હોવા જોઈએ",
    required: "જરૂરી છે",
    invalid_email: "અમાન્ય ઇમેલ સરનામું",
    must_be_10_digits: "ખાશક જ 10 અંકો હોવા જોઈએ",
    password_required: "પાસવર્ડ જરૂરી છે",
    birthdate_future: "જન્મતારીખ ભવિષ્યમાં હોઈ નહિ શકે",
    email_already_exist: "*કૃપા કરીને આગળ વધવા માટે અલગ ઇમેલનો ઉપયોગ કરો!",
    selectbankname: "બેંક નામ પસંદ કરો",
    selectaccounttype: "એકાઉન્ટ પ્રકાર પસંદ કરો",
    selectreportingmanager: "રિપોર્ટિંગ મેનેજર પસંદ કરો",
    done: "થયુ",
    addassignarea: "અસાઇન એરીયા ઉમેરો",
    editassignarea: "અસાઇન એરીયા એડિટ કરો",
    selectcategory: "શ્રેણી પસંદ કરો",
    searchforacategory: "શ્રેણી માટે શોધો...",
    selectvillageswanttoassign: "સોંપવા માંગતા ગામો પસંદ કરો",
    searchforavillage: "ગામ માટે શોધો...",
    close: "બંધ",
    save: "સેવ",
    areyousuredeleteassignarea: "શું તમે અસાઇન એરીયા કાઢી નાખી દેવામાં સહમત છો",
    assignareadeleted: "અસાઇન એરીયા કાઢી મૂકાયો",

    // AddTask validation messages (Gujarati)
    select_at_least_one_employee: "કૃપા કરીને ઓછામાં ઓછા એક કર્મચારી પસંદ કરો",
    task_type_required: "ટાસ્ક પ્રકાર જરૂરી છે",
    task_required: "ટાસ્ક જરૂરી છે",
    select_at_least_one_category: "કૃપા કરીને ઓછામાં ઓછા એક કેટેગરી પસંદ કરો",
    must_be_number: "સંખ્યાનો હોવો જોઈએ",
    must_be_positive: "ધનાત્મક હોવું જોઈએ",
    task_count_required: "ટાસ્ક ગણતરી જરૂરી છે",
    time_period_required: "સમય ઍવધિ જરૂરી છે",
    allocation_type_required: "આવટો પ્રકાર જરૂરી છે",
    start_date_required: "શરૂઆત તારીખ જરૂરી છે",
    end_date_required: "અંત તારીખ જરૂરી છે",
    end_date_after_start: "અંત તારીખ શરૂ થાય ત્યાર પછી હોવી જોઈએ",
    selectparentfield: "પેરેંટ ફિલ્ડ પસંદ કરો",
    selectparentfieldplaceholder: "પેરેંટ ફિલ્ડ પસંદ કરો",
    entercustomlabel: "કસ્ટમ લેબલ દાખલ કરો",
    selectfieldtype: "ફીલ્ડ પ્રકાર પસંદ કરો",
    selectfieldtypeplaceholder: "ફીલ્ડ પ્રકાર પસંદ કરો",
    fieldtype_textbox: "ટેક્સ્ટ બોક્સ",
    fieldtype_selectbox: "સિલેક્ટ બોક્સ",
    fieldtype_checkbox: "ચેકબૉક્સ",
    fieldtype_radiobutton: "રેડિયો બટન",
    fieldtype_date: "ડેટ બોક્સ",
    addfield: "ફીલ્ડ ઉમેરો",
    showallcustomfieldhint:
      "સમસ્ત કસ્ટમ ફીલ્ડ યાદી બતાવવા માટે કૃપા કરી ચોક્કસ પેરેંટ ફિલ્ડ પસંદ કરો",
    fieldcreated: "ફીલ્ડ બનાવાયું",
    childfieldcreated: "ચાઇલ્ડ ફિલ્ડ બનાવાયો",
    fielddeleted: "ફીલ્ડ ડીલીટ થયું",
    fielddeletefailed: "ફીલ્ડ ડીલીટ કરવામાં નિષ્ફળ",
    createdepartment: "વિભાગ બનાવો",
    editdepartment: "વિભાગ એડિટ કરો",
    departmentname: "વિભાગનું નામ",
    departmentdescription: "વિભાગનું વર્ણન",
    addmanufacturer: "ઉત્પાદક ઉમેરો",
    manufacturername: "ઉત્પાદક નામ",
    manufacturerdescription: "ઉત્પાદક વર્ણન",
    manufacturerlink: "ઉત્પાદક લિંક",
    manufacturerfile: "ઉત્પાદક ફાઇલ",
    addmodal: "મોડલ ઉમેરો",
    editmodal: "મોડલ એડિટ કરો",
    modalname: "મોડલ નામ",
    modallink: "મોડલ લિંક",
    brochurefile: "બ્રોશર ફાઈલ",
    modallist: "મોડલ યાદી",
    update: "અપડેટ",
    manufacturer: "ઉત્પાદક",
    manufacture: "ઉત્પાદન",
    modal: "મોડલ",
    areyousuredeletemodal: "શું તમે મોડલ ડીલીટ કરવા માટે સહમત છો",
    enquirysourceslist: "પૂછપરછ સ્રોત યાદી",
    enquiryprimarysourcesname: "પૂછપરછ પ્રાથમિક સ્ત્રોતોનું નામ",
    addenquiryprimarysource: "પૂછપરછ પ્રાથમિક સ્ત્રોત ઉમેરો",
    enquiryprimarysourcename: "પૂછપરછ પ્રાથમિક સ્ત્રોતનું નામ",
    enquiryprimarysourcedescription: "પૂછપરછ પ્રાથમિક સ્ત્રોતનું વર્ણન",
    addenquirysource: "પૂછપરછ સ્ત્રોત ઉમેરો",
    editsourcesname: "પૂછપરછ સ્ત્રોત એડિટ કરો",
    enquirysourcesname: "પૂછપરછ સ્ત્રોતોનું નામ",
    areyousureadddelete: "શું તમે પૂછપરછ સ્ત્રોત ડીલીટ કરવા માટે સહમત છો",
    areyousuredbdelete: "શું તમે પૂછપરછ સ્ત્રોત ડીલીટ કરવા માટે સહમત છો",
    offername: "ઓફરનું નામ",
    isactive: "સક્રિય છે",
    offer: "ઓફર",
    whatsapp: "વોટ્સએપ",
    appkey: "એપ કી",
    authkey: "ઑથ કી",
    savechanges: "બદલાવ સેવ કરો",
    agencypicture: "એજન્સી ચિત્ર",
    action: "એક્શન",
    messages: "મેસેજિસ",
    taskadded: "ટાસ્ક સફળતાપૂર્વક ઉમેરા",
    taskupdated: "ટાસ્ક સફળતાપૂર્વક અપડેટ કર્યો",
    somethingwrong: "કંઈક ખોટું છે!",
    required: "જરૂરી છે",

    // Delete Confirmation Messages (Gujarati)
    deleteconfirmation: "ડીલીટ કરવાની પુષ્ટિ",
    areyousuredelete: "શું તમે નિશ્ચિત છો કે તમે આને ડીલીટ કરવા માંગો છો",
    deletebranchmsg: "શું તમે શાખા ડીલીટ કરવા માટે સહમત છો",
    confirmdelete: "ડીલીટ કરવાની પુષ્ટિ",
    cancel: "રદ કરો",
    delete: "ડીલીટ",
    deletesuccessfully: "વસ્તુ સફળતાપૂર્વક કાઢી મૂકાઈ",
    deletefailed: "વસ્તુ કાઢવામાં નિષ્ફળ",
    userinfo: "વપરાશકર્તા માહિતી",
    assignarea: "એરીયા સોંપો",
    areaAssign: "એરીયા-સોંપો",
    addAsignArea: "એરીયા-સોંપો-ઉમેરો",
    newrole: "નવી ભૂમિકા",
    editrole: "ભૂમિકા એડિટ કરો",
    rolename: "ભૂમિકાનું નામ",
    enterrolename: "ભૂમિકાનું નામ દાખલ કરો",
    roledescription: "ભૂમિકાનું વર્ણન",
    enteroledescription: "ભૂમિકા માટે વર્ણન દાખલ કરો",
    assignedfeatures: "સોંપાયેલ વિશેષતાઓ",
    selectfeatures: "આ ભૂમિકા માટે સોંપવા માટે વિશેષતાઓ પસંદ કરો.",
    createrole: "ભૂમિકા બનાવો",
    pleasefillallfield: "કૃપા કરીને બધા ક્ષેત્રો ભરો",
    roleiscreated: "ભૂમિકા બનાવી દેવામાં આવી છે",
    deleterolmsg: "શું તમે ભૂમિકા ડીલીટ કરવા માટે સહમત છો",
    taskreport: "કાર્ય રિપોર્ટ",
    taskreportdesc: "કાર્યો સંચાલન અને ટ્રેક કરો",
    salesreport: "વિક્રય રિપોર્ટ",
    salesreportdesc: "વિક્રય કર્મક્ષમતા વિશ્લેષણ કરો",
    trackingreport: "ટ્રેકિંગ રિપોર્ટ",
    trackingreportdesc: "પ્રગતિ અને હલનચલન ટ્રેક કરો",
    activityreport: "પ્રવૃત્તિ રિપોર્ટ",
    activityreportdesc: "દૈનિક પ્રવૃત્તિ મોનિટર કરો",
    leadreport: "લીડ રિપોર્ટ",
    leadreportdesc: "લીડ્સ અને રૂપાંતર ટ્રેક કરો",
    targetreport: "લક્ષ્ય રિપોર્ટ",
    targetreportdesc: "લક્ષ્ય પ્રાપ્તિ અને પ્રગતિ મોનિટર કરો",
    dailytargets: "દૈનિક લક્ષ્યો",
    weeklytargets: "સાપ્તાહિક લક્ષ્યો",
    monthlytargets: "માસિક લક્ષ્યો",
    annualtargets: "વાર્ષિક લક્ષ્યો",
    customtargets: "કસ્ટમ લક્ષ્યો",
    opportunityreport: "તક રિપોર્ટ",
    opportunityreportdesc: "સંભવિત તકો જુઓ",
    campaignreport: "ક્ષેત્ર રિપોર્ટ",
    campaignreportdesc: "ક્ષેત્ર કર્મક્ષમતા મૂલ્યાંકન કરો",
    customerreport: "ગ્રાહક રિપોર્ટ",
    customerreportdesc: "ગ્રાહક જનસંખ્યા સમજો",
    supportticketreport: "સમર્થન ટિકેટ રિપોર્ટ",
    supportticketreportdesc: "સમર્થન ટિકેટ મોનિટર કરો",
    financialreport: "આર્થિક રિપોર્ટ",
    financialreportdesc: "આર્થિક મેટ્રિક્સનું અવલોકન",
    dailysales: "દૈનિક વિક્રય",
    monthlysales: "માસિક વિક્રય",
    customsales: "કસ્ટમ વિક્રય",
    annualsales: "વાર્ષિક વિક્રય",
    dailytracking: "દૈનિક ટ્રેકિંગ",
    weeklytracking: "સાપ્તાહિક ટ્રેકિંગ",
    monthlytracking: "માસિક ટ્રેકિંગ",
    dailyactivity: "દૈનિક પ્રવૃત્તિ",
    weeklyactivity: "સાપ્તાહિક પ્રવૃત્તિ",
    monthlyactivity: "માસિક પ્રવૃત્તિ",
    newleads: "નવી લીડ્સ",
    convertedleads: "રૂપાંતરિત લીડ્સ",
    customleadreport: "કસ્ટમ લીડ રિપોર્ટ",
    openopportunities: "ખુલ્લી તકો",
    closedopportunities: "બંધ તકો",
    customopportunity: "કસ્ટમ તક",
    emailcampaign: "ઈમેલ ક્ષેત્ર",
    socialcampaign: "સોશ્યલ ક્ષેત્ર",
    customcampaign: "કસ્ટમ ક્ષેત્ર",
    activecustomers: "સક્રિય ગ્રાહકો",
    inactivecustomers: "નિષ્ક્રિય ગ્રાહકો",
    customcustomerreport: "કસ્ટમ ગ્રાહક રિપોર્ટ",
    opentickets: "ખુલ્લી ટિકિટો",
    pendingtickets: "લંબિત ટિકિટો",
    resolvedtickets: "હલ કરાયેલ ટિકિટો",
    customsupportreport: "કસ્ટમ સમર્થન રિપોર્ટ",
    revenuereport: "આવક રિપોર્ટ",
    expensereport: "ખર્ચ રિપોર્ટ",
    profitanalysis: "નફો વિશ્લેષણ",
    customfinancialreport: "કસ્ટમ આર્થિક રિપોર્ટ",
    distributiontype: "વિતરણ પ્રકાર",
    addrole: "ભૂમિકા ઉમેરો",
    allreports: "બધા રિપોર્ટ્સ",
    analytics: "એનલિટિક્સ",
    id: "આઇડી",
    employeeName: "કર્મચારી નામ",
    categoryName: "શ્રેણી નામ",
    customerName: "ગ્રાહક નામ",
    phoneNumber: "ફોન નંબર",
    village: "ગામ",
    taskName: "કાર્ય નામ",
    outcomeStatus: "પરિણામ સ્થિતિ",
    attemptDate: "પ્રયાસ તારીખ",
    notes: "નોટ્સ",
    selectEmployee: "કર્મચારી પસંદ કરો",
    selectCategory: "શ્રેણી પસંદ કરો",
    selectStatus: "સ્થિતિ પસંદ કરો",
    startDate: "શરૂ તારીખ",
    endDate: "અંત તારીખ",
    taskAnalyticsReport: "કાર્ય વિશ્લેષણ રિપોર્ટ",
    loadingPleaseWait: "લોડ થઈ રહ્યું છે, કૃપા કરી રાહ જુઓ...",
    tasklist: "કાર્ય યાદી",
    allocationtype: "ફાળવણીનો પ્રકાર",
    taskarea: "કાર્ય વિસ્તાર",
    tasktype: "કાર્ય પ્રકાર",
    selectTaskType: "કાર્ય પ્રકાર પસંદ કરો",
    selectTask: "કાર્ય પસંદ કરો",
    selectTaskTimePeriod: "કાર્ય સમય અવધિ પસંદ કરો",
    taskAllocationtype: "કાર્ય ફાળવણી પ્રકાર",
    selectAllocationtype: "ફાળવણી પ્રકાર પસંદ કરો",
    selectTaskArea: "કાર્ય વિસ્તાર પસંદ કરો",
    areaAllocatedPerson: "વિસ્તાર ફાળવણી કર્મચારી",
    selectAreaAllocatedPerson: "વિસ્તાર ફાળવણી કર્મચારી પસંદ કરો",
    outcomeType: "પરિણામ પ્રકાર",
    selectOutcometype: "પરિણામ પ્રકાર પસંદ કરો",
    taskStatus: "કાર્ય સ્થિતિ",
    selectTaskStatus: "કાર્ય સ્થિતિ પસંદ કરો",
    updateTask: "કાર્ય અપડેટ કરો",
    createTask: "કાર્ય બનાવો",
    addtask: "કાર્ય ઉમેરો",
    edittask: "કાર્ય એડિટ કરો",
    globalSearch: "વૈશ્વિક શોધ...",
    download: "ડાઉનલોડ કરો",
    revert: "ફરી આવો",
    no: "નં",
    customerName: "ગ્રાહક નામ",
    village: "ગામ",
    taluka: "તાલુકો",
    phoneNumber: "ફોન નંબર",
    deliveryDate: "ડિલીવરી તારીખ",
    soldDate: "વેચાઇ ગયાની તારીખ",
    soldNote: "વેચાઇ ગયાની નોટ",
    model: "મોડલ",
    chassisNo: "ચેસિસ નંબર",
    engineNo: "એન્જિન નંબર",
    noDataAvailable: "કોઈ ડેટા ઉપલબ્ધ નથી",
    confirmRevert: "ફરી આવવાની પુષ્ટિ",
    areYouSureRevert:
      "શું તમે આ ટ્રેક્ટરને 'વેચાઇ ગયું' સ્થિતિમાંથી ફરી આવતા કરવા માટે ખાતરી છો?",
    yesRevert: "હા, ફરી આવો",
    yes: "હા",
    no: "ના",
    followUp: "ફોલો અપ",
    lastServiceHours: "છેલ્લી સર્વિસ અવર",
    serviceHours: "સર્વિસ અવર",
    tractorSold: "ટ્રેક્ટર વેચાયો",
    tractorSoldStatus: "ટ્રેક્ટર વેચાયેલ સ્થિતિ",
    selectOption: "વિકલ્પ પસંદ કરો...",
    additionalInfo: "વધારાની માહિતી / ટિપ્પણીઓ",
    customerDetails: "ગ્રાહક વિગતો",
    pleaseFillDetails: "મહેરબાની કરીને માટે જરૂરી વિગતો ભરો",
    saveData: "ડેટા સાચવો",
    enterPlaceholder: "પ્રવેશ કરો {field}...",
    back: "પાછળ",
    scheduledService: "અનુસૂચિત સેવા",
    dueDate: "બાકીની તારીખ",
    scheduleNote: "શિડ્યુલ નોટ",
    lastServiceNote: "છેલ્લી સર્વિસ નોટ",
    modal: "મોડલ",
    chassis: "ચેસિસ",
    engine: "એન્જિન",
    totalHours: "કુલ અવર",
    servicesDue: "બાકી સર્વિસ",
    serviceDetails: "સર્વિસ વિગતો",
    serviceAndCustomerInfo: "સર્વિસ અને ગ્રાહક માહિતી",
    associatedServices: "સંબંધિત સેવાઓ",
    loadingPleaseWait: "લોડ થઈ રહ્યું છે, કૃપા કરી રાહ જુઓ...",
    noServicesAvailable: "કોઈ સર્વિસ ઉપલબ્ધ નથી",
    thService: "મી સર્વિસ",
    serviceMilestone: "સર્વિસ માઇલસ્ટોન",
    customerName: "ગ્રાહક નામ",
    dueDate: "બાકીની તારીખ",
    modal: "મોડલ",
    chassis: "ચેસિસ",
    engine: "એન્જિન",
    lastHours: "છેલ્લા અવર",
    totalHours: "કુલ અવર",
    deliveryDate: "ડેલિવરીની તારીખ",
    globalSearch: "વૈશ્વિક શોધ...",
    noDataAvailable: "કોઈ ડેટા ઉપલબ્ધ નથી",
    allServicesData: "બધી સર્વિસ ડેટા",
    financialYear: "આર્થિક વર્ષ",
    download: "ડાઉનલોડ",
    model: "મોડલ",
    chassisNo: "ચેસિસ નંબર",
    engineNo: "એન્જિન નંબર",
    manufacture: "ઉત્પાદન",
    chassisNumber: "ચેસિસ નંબર",
    engineNumber: "એન્જિન નંબર",
    taluka: "તાલુકો",
    village: "ગામ",
    phoneNumber: "ફોન નંબર",
    menu: "મેનુ",
    pdfPreview: "PDF પૂર્વાવલોકન",
    serviceFollowUp: "સર્વિસ ફોલો-અપ",
    customer: "ગ્રાહક",
    phone: "ફોન",
    followUpNote: "ફોલો-અપ નોટ",
    nextFollowUpDate: "આગલી ફોલો-અપ તારીખ",
    followUpHistory: "ફોલો-અપ ઇતિહાસ",
    date: "તારીખ",
    nextFollowUp: "આગલું ફોલો-અપ",
    note: "નોટ",
    followedBy: "દ્વારા અનુસરણ",
    cancel: "રદ કરો",
    submit: "સબમિટ કરો",
    recordService: "સર્વિસ રેકોર્ડ કરો",
    lastServiceHours: "છેલ્લી સર્વિસ અવર",
    serviceDate: "સર્વિસ તારીખ",
    serviceNote: "સર્વિસ નોટ...",
    followUp: "ફોલો અપ",
    no: "ક્રમાંક",
    name: "નામ",
    modelName: "મોડેલ નામ",
    engineNumber: "એન્જિન નંબર",
    chassisNumber: "ચેસિસ નંબર",
    detailedServiceOverview: "વિસ્તૃત સેવા સમીક્ષા",
    engineHash: "એન્જિન #",
    chassisHash: "ચેસિસ #",
    model: "મોડલ",
    lastServiceHours: "છેલ્લી સર્વિસ અવર",
    downloadPdf: "PDF ડાઉનલોડ કરો",
    downloadExcel: "Excel ડાઉનલોડ કરો",
    followUp: "ફોલો અપ",
    sold: "વેચાઈ ગયું",
    due: "બાકી",
    bilNo: "બિલ ક્રમાંક",
    ndp: "NDP",
    bumCod: "BUM કોડ",
    modal: "મોડલ",
    chassis: "ચેસિસ",
    engine: "એન્જિન",
    deliveryDate: "ડિલિવરી તારીખ",
    customerName: "ગ્રાહક નામ",
    sample: "નમૂનો",
    upload: "અપલોડ",
    exportCsv: "CSV નિકાસ",
    bil: "બિલ",
    steps: "પગલાં",
    location: "સ્થાન",
    stagename: "સ્ટેજનું નામ",
    enquiryDate: "પૂછપરછની તારીખ",
    createdBy: "બનાવેલ",
    paymentMethod: "ચૂકવણી પદ્ધતિ",
    paymentDetails: "ચૂકવણી વિગતો",
    lastDiscussion: "છેલ્લો આલોચન",
    lastFollowupDate: "છેલ્લી ફોલો-અપ તારીખ",
    lastFollowupPerson: "છેલ્લી ફોલો-અપ વ્યક્તિ",
    oldDetails: "જુની વિગતો",
    oldTractorPrice: "જુના ટ્રેક્ટરનો ભાવ",
    newTractorPrice: "નવો ટ્રેક્ટર ભાવ",
    manufactureName: "ઉત્પાદક નામ",
    modelName: "મોડેલ નામ",
    salesPersonName: "વિક્રય વ્યક્તિનું નામ",
    districtName: "જિલ્લાનું નામ",
    talukName: "તાલુકાનું નામ",
    villageName: "ગામનું નામ",
    phoneNumber: "ફોન નંબર",
    whatsappNumber: "વોટ્સએપ નંબર",
    edit: "એડિટ",
    delete: "ડીલીટ",
    moveToStage: "સ્ટેજમાં ખસેડો",
    newModal: "નવું મોડલ",
    nextFollowupDate: "આગલી ફોલો-અપ તારીખ",
    stageName: "સ્ટેજ નામ",
    firstNameLabel: "પ્રથમ નામ",
    salesPersonLabel: "વિક્રય વ્યક્તિ",
    phoneNoLabel: "ફોન નંબર",
    whatsappNumberLabel: "વોટ્સએપ નંબર",
    manufacturerNameLabel: "ઉત્પાદક",
    modelNameLabel: "મોડેલ",
    newTractorPriceLabel: "નવો ટ્રેક્ટર ભાવ",
    oldTractorsLabel: "જુના ટ્રેક્ટર",
    oldTractorPriceLabel: "જુના ટ્રેક્ટરનો ભાવ",
    primarySourceLabel: "મુખ્ય સ્ત્રોત",
    enquirySourceLabel: "પૂછપરછ સ્ત્રોત",
    createdByLabel: "બનાવેલ",
    nextFollowupDateLabel: "આગલી ફોલો-અપ તારીખ",
    allEnquiries: "તમામ પૂછપરછો",
    selectCategory: "શ્રેણી પસંદ કરો",
    filterBy: "ફિલ્ટર કરો",
    downloadExcel: "એક્સેલ ડાઉનલોડ કરો",
    noRecordsFound: "કોઈ રેકોર્ડ નથી મળ્યા",
    loading: "લોડ થઈ રહ્યું છે...",
    error: "ભૂલ",
    success: "સફળતા",
    warning: "ચેતવણી",
    confirm: "પુષ્ટિ કરો",
    user: "યૂઝર",
    // Depo related translations
    depo: "ડેપો",
    addDepo: "ડેપો ઉમેરો",
    inDepo: "ડેપોમાં",
    inDepot: "ડેપોમાં",
    depoStock: "ડેપો સ્ટોક",
    addDelivery: "ડિલિવરી ઉમેરો",
    sample: "નમૂનો",
    upload: "અપલોડ કરો",
    globalSearch: "વૈશ્વિક શોધ...",
    menu: "મેનુ",
    stock: "સ્ટોક",
    bilNo: "બિલ ક્રમાંક",
    date: "તારીખ",
    bumCod: "BUM કોડ",
    modal: "મોડલ",
    chassis: "ચેસિસ",
    engine: "એન્જિન",
    ndp: "NDP",
    location: "સ્થાન",
    number22: "નંબર22",
    status: "સ્થિતિ",
    noDataAvailable: "કોઈ ડેટા ઉપલબ્ધ નથી",
    deliverysalesman: "ડિલિવરી સેલ્સમેન",
    salesp: "સેલ્સ પર્સન",
    enquiryad: "પૂછપરછ એડમિન",
    customerName: "ગ્રાહકનું નામ",
    retailDate: "રિટેલ તારીખ",
    remainingPrice: "બાકી કિંમત",
    isOldOwned: "શું જૂનું ટ્રેક્ટર છે?",
    selectDistrict: "જિલ્લો પસંદ કરો",
    selectTaluka: "તાલુકો પસંદ કરો",
    selectVillage: "ગામ પસંદ કરો",
    selectEnquirySource: "પૂછપરછ સ્ત્રોત પસંદ કરો",
    selectDeliverySalesman: "ડિલિવરી સેલ્સમેન પસંદ કરો",
    selectSalesPerson: "સેલ્સ પર્સન પસંદ કરો",
    enquiryAd: "પૂછપરછ જાહેરાત",
    selectEnquiryAd: "પૂછપરછ એડમિન પસંદ કરો",
    selectModel: "મોડેલ પસંદ કરો",
    selectChassis: "ચેસિસ પસંદ કરો",
    selectEngine: "એન્જિન પસંદ કરો",
    selectMake: "મેક પસંદ કરો",
    selectYear: "વર્ષ પસંદ કરો",
    paymentMethod: "ચુકવણી પદ્ધતિ",
    selectPaymentMethod: "ચુકવણી પદ્ધતિ પસંદ કરો",
    paymentDetails: "ચુકવણી વિગતો",
    selectPaymentDetails: "ચુકવણી વિગતો પસંદ કરો",
    selectBankName: "બેંકનું નામ પસંદ કરો",
    make: "મેક",
    year: "વર્ષ",
    saveChanges: "ફેરફારો સાચવો",
  },
};

export default translations;
